import { buildAuthTokens } from '~/utils/jwt/authToken';

export default defineNuxtRouteMiddleware(async () => {
    if (!import.meta.server) {
        return;
    }

    await buildAuthTokens(useRuntimeConfig().jwtPrivateKey.replace(/\\n/g, '\n'));
});
